export const $ErrorsModuleName = "errors";

export type TErrorsState = {
    alerts: Array<any>;
};

export type Error = {
    url: string;
    message: string;
    method: string;
};